import EventHandler from '../../utils/dom/event-handler';
import SelectorEngine from '../../utils/dom/selector-engine';
import Manipulator from '../../utils/dom/manipulator';
import Request from '../../utils/request';
import { Loader } from '@googlemaps/js-api-loader';

class FindCoach {
	constructor () {
		this.map = {};
		this.position = {
			latitude: 0,
			longitude: 0
		};
		this.dataFetched = false;
		this.markerData = {};
		this.initEvents();
	}

	initEvents() {
		const listButton = SelectorEngine.findOne('.lta-coach-search-tabs #lta-view-tab-1');
		const mapButton = SelectorEngine.findOne('.lta-coach-search-tabs #lta-view-tab-2');
		const sortBy = SelectorEngine.findOne('.lta-filter-panel__sort-by');
		const sortByChild = SelectorEngine.findOne('.lta-modal-fullscreen #sort-id');
		const searchSelectItems = SelectorEngine.find('.lta-search-field__wrapper .lta-select__item');
		const SortByMobile = sortByChild ? sortByChild.parentNode.parentNode : null

		EventHandler.on(mapButton, 'click', (e) => {
			e.preventDefault();
			sortBy.classList.add('is-disabled');
			SortByMobile.classList.add('u-hidden');
		});

		EventHandler.on(listButton, 'click', (e) => {
			e.preventDefault();
			sortBy.classList.remove('is-disabled');
			SortByMobile.classList.remove('u-hidden');
		});

		// If selectOption not Location disable Map view
		if (mapButton) {
			searchSelectItems.forEach( (e) => {
				EventHandler.on(e, 'click', (event) => {
					event.preventDefault();
					const self = event.target;
					const content = self.innerHTML;

					if (content == 'Location' || content == 'location') {
						mapButton.classList.remove('is-disabled');
					} else {
						if (mapButton.getAttribute('aria-selected') == 'true') {
							listButton.click();
						}
						mapButton.classList.add('is-disabled');
					}
				});
			});
		}

		let expand = SelectorEngine.find('.js-card-expand');

		expand.forEach( (e) => {
			let self = e;
			let button = self.querySelector('a.u-link1');

			if ( window.matchMedia('(max-width: 768px)').matches ) {
				const notHidden = self.querySelectorAll('span:not(:first-child):not(.u-hidden)');

				notHidden.forEach( (e) => {
					e.classList.add('u-hidden');
				});
			}

			EventHandler.on(button, 'click', (e) => {
				let self = e.target;
				e.preventDefault();
				const hidden = self.parentNode.querySelectorAll('span.u-hidden');
				hidden.forEach( (e) => {
					e.classList.remove('u-hidden');
				});

				self.classList.add('u-hidden');
				self.classList.remove('u-block');
			});
		});
	}

	loadMap(locations, centerPos) {
		const loader = new Loader({
			apiKey: 'AIzaSyDpXhOEnRc3Oxh0Ec-56UFLC5XubgPfgj4',
			version: 'weekly',
			libraries: []
		});
		loader.load()
			.then((google) => {
				this.map = new google.maps.Map(document.querySelector('.lta-map'), {
					zoom:12
				});

				this.map.setCenter(centerPos);
				if(locations.length > 0) {
					locations.forEach((marker, index) => {
						console.log(marker, index);
						let pin = new google.maps.Marker({
							position: new google.maps.LatLng(marker.Latitude, marker.Longitude),
							map: this.map
						});
						pin.addListener('click', () => {
							Request.get(`/api/coach/CoachesForVenue/?latitude=${marker.Latitude}&longitude=${marker.Longitude}&venueId=${marker.Id}`)
								.then((response) => {

									let contentString = "<div id='content'>" +
									"<h1>" + response.VenueName + "</h1>" +
									"<div id='bodyContent'>" +
									"<ul>";
									response.Coaches.forEach((coach) => {
										contentString += "<li>" + coach.Name + "</li>";
									});
									contentString += "</ul>" +
									"</div>" +
									"</div>";
									console.log('In pin click');
									console.log(contentString);
									const infowindow = new google.maps.InfoWindow({
										content: contentString
									});
									infowindow.open({
										anchor: pin,
										map: this.map,
										shouldFocus: false
									});
								})
						});
					})
				}
			})
			.catch((error) => { alert(error) });
	}

	hideLoader() {
		const mapWrapper = SelectorEngine.findOne('.lta-mapWrapper.lta-loader');
		SelectorEngine.findOne('.lta-mapWrapper.lta-loader > img').remove();
		mapWrapper.classList.remove('lta-loader');
	}

	setMapData() {
		const mapWrapper = SelectorEngine.findOne('.lta-map');
		const customEvent = new CustomEvent('map-has-location');
		Manipulator.setDataAttribute(mapWrapper, 'latitude', this.position.latitude);
		Manipulator.setDataAttribute(mapWrapper, 'longitude', this.position.longitude);
		EventHandler.trigger(mapWrapper, 'map-has-location');
	}
	// Ajax request for taking all the coaches that teach on a venue from a marker
}

const globalFindCourt = new FindCoach();

export default globalFindCourt;

